import { useCallback, useContext, forwardRef, useEffect, useMemo, useRef, useState, useImperativeHandle } from "react"

import styles from "./index.module.scss"
import { Button, Popover, Spin, Upload, message } from "antd"
import { QuestionCircleFilled } from '@ant-design/icons';
import { multiSemantic, interactiveNpy, shoesMask } from '@utils/workflowOfPrediction'
import SingleExtraction from "./SingleExtraction"
import UtilsEdit from '@utils/utils_edit'
import Utils from '@utils/utils'
import * as _ from "underscore";
import { AppContext } from '@utils/AppContext';
import { GenerateContext } from "@utils/GenerateContext"
import API, { commonApiInvoker } from '@api/api'

const MultiSemantic = forwardRef((props, ref) => {


    useImperativeHandle(ref, () => ({
        handleFinish
    }))

    const { selectedColor, setMultiMasks, multiMasks } = useContext(GenerateContext)
    const { setGlobalLoading } = useContext(AppContext)
    const {originUrl} = props


    const [current, setCurrent] = useState(0)
    const [list, setList] = useState([{
        key: 'recolor_key',
        originImageWidth: null, // 原始图片的width
        originImageHeight: null, // 原始图片的height
        url: null, // 如果超出4096，resize后的图片url（实际处理图片的url）
        imageWidth: null, // 实际处理图片的width
        imageHeight: null, // 实际处理图片的height
        useOrigin: true,
        multiMasks: null, // 多语义分割的结果
        // originEditedMask: {
        //     binaryMask: 'https://oss-cdn-inner.psai.cn/aigc/upload/out-shoesseg-mask-Q7H8o5Asyafd5a8ec48347fc433392710769db7528f5-565995891-id-2.png',
        //     foregroundAlphaMask: 'https://oss-cdn-inner.psai.cn/aigc/upload/out-shoesseg-fullbody-alpha-Q7H8o5Asyafd5a8ec48347fc433392710769db7528f5-565995891-id-1.png',
        // },
        originEditedMask: null,
        editedMask: null, // 实际处理图片的编辑结果 {binaryMask, foregroundAlphaMask}
        editedMaskBase64: null, // 实际处理图片的编辑结果base64
        interactiveNpy: '', // 交互式分割的npy文件
        loading: false,
        hasEditedMask: false,
    }])
    const isMounted = useRef(true)

    useEffect(() => {
        return () => isMounted.current = false
    }, [])

    const currItem = useMemo(() => {
        return list[current]
    }, [current, list])

    useEffect(() => {
        if (currItem.interactiveNpy || !originUrl) return
        getCurrInteractiveNpyAndImageSize(list[0])
    }, [originUrl])

    const setItemHasEditedMask = (key, hasEditedMask) => {
        setList(pre => {
            const temp = [...pre]
            const item = temp.find(item => item.key == key)
            item.hasEditedMask = hasEditedMask
            return temp
        })
    }
    const setItemLoading = (key, loading) => {
        setList(prevList =>
            prevList.map(item =>
                item.key === key
                    ? { ...item, loading: loading }
                    : item
            )
        );
    };
    const setItemMasks = (key, output) => {
        setList(pre => {
            const temp = [...pre]
            const item = temp.find(item => item.key == key)
            item.multiMasks = output
            return temp
        })
    }
    const setItemImageSize = (key, originImgSize, imgSize, useOrigin) => {
        setList(pre => {
            const temp = [...pre]
            const item = temp.find(item => item.key == key)
            item.originImageWidth = originImgSize.width
            item.originImageHeight = originImgSize.height
            item.imageWidth = imgSize.width
            item.imageHeight = imgSize.height
            item.useOrigin = useOrigin
            return temp
        })
    }
    const setItemImageUrl = (key, url) => {
        setList(pre => {
            const temp = [...pre]
            const item = temp.find(item => item.key == key)
            item.url = url
            return temp
        })
    }
    const setItemEditedMask = (key, editedMask) => {
        setList(pre => {
            const temp = [...pre]
            const item = temp.find(item => item.key == key)
            item.editedMask = editedMask
            return temp
        })
    }
    const setItemEditedMaskBase64 = (key, editedMaskBase64) => {
        setList(pre => {
            const temp = [...pre]
            const item = temp.find(item => item.key == key)
            item.editedMaskBase64 = editedMaskBase64
            return temp
        })
    }
    const setItemInteractiveNpy = (key, interactiveNpy) => {
        setList(pre => {
            const temp = [...pre]
            const item = temp.find(item => item.key == key)
            item.interactiveNpy = interactiveNpy
            return temp
        })
    }

    const getCurrInteractiveNpyAndImageSize = async (item) => {
        try {
            setItemLoading(item.key, true)
            // 计算图片尺寸
            const MAX = 4096
            const originImgSize = await UtilsEdit.getImageDimensions(originUrl)
            let url = originUrl
            let useOrigin = true
            let imgSize = { ...originImgSize }
            if (Math.max(originImgSize.width, originImgSize.height) > MAX) {
                useOrigin = false
                const aspectRatio = originImgSize.width / originImgSize.height
                if (originImgSize.width > originImgSize.height) {
                    imgSize.width = MAX
                    imgSize.height = Math.floor(imgSize.width / aspectRatio)
                } else {
                    imgSize.height = MAX
                    imgSize.width = Math.floor(imgSize.height * aspectRatio)
                }
            }
            setItemImageSize(item.key, originImgSize, imgSize, useOrigin)
            // 计算图片url
            if (!useOrigin) {
                const MAX_IMAGE_SIZE = 50 * 1024 * 1024
                url = UtilsEdit.addParamsToUrl(url, { "x-oss-process": `image/resize,w_${imgSize.width},h_${imgSize.height},m_fixed` })
                // 将url去掉x-oss-process，算法不支持
                let response = await fetch(url)
                if (response.status != 200) throw new Error(`图片大小不能超过${MAX_IMAGE_SIZE / 1024 / 1024}MB`)
                let blob = await response.blob()
                let file = new File([blob], "image.png", { type: 'image/png' })
                url = await Utils.uploadFile(file)
            }
            setItemImageUrl(item.key, url)
            // 处理editedMask
            const originEditedMask = item.originEditedMask || multiMasks
            let editedMask
            if (originEditedMask && Object.keys(originEditedMask).length > 0) {
                editedMask = { ...originEditedMask }
                if (!useOrigin) {
                    editedMask.binaryMask = UtilsEdit.addParamsToUrl(editedMask.binaryMask, { "x-oss-process": `image/resize,w_${imgSize.width},h_${imgSize.height},m_fixed` })
                    editedMask.foregroundAlphaMask = UtilsEdit.addParamsToUrl(editedMask.foregroundAlphaMask, { "x-oss-process": `image/resize,w_${imgSize.width},h_${imgSize.height},m_fixed` })
                }
                setItemEditedMask(item.key, editedMask)
                // 处理editedMaskBase64
                const editedMaskBase64 = { ...editedMask }
                editedMaskBase64.binaryMask = await UtilsEdit.urlToBase64(editedMask.binaryMask)
                editedMaskBase64.foregroundAlphaMask = await UtilsEdit.urlToBase64(editedMask.foregroundAlphaMask)
                setItemEditedMaskBase64(item.key, editedMaskBase64)
            } else {
                const res = await shoesMask(url, () => !isMounted.current)
                editedMask = { binaryMask: res.output[2],  foregroundAlphaMask: res.output[1]}
                setMultiMasks(editedMask)
                setItemEditedMask(item.key, editedMask)
                // 处理editedMaskBase64
                const editedMaskBase64 = { ...editedMask }
                editedMaskBase64.binaryMask = await UtilsEdit.urlToBase64(editedMask.binaryMask)
                editedMaskBase64.foregroundAlphaMask = await UtilsEdit.urlToBase64(editedMask.foregroundAlphaMask)
                
                setItemEditedMaskBase64(item.key, editedMaskBase64)
            }
            let imgPath = url
            let maskPath = editedMask.binaryMask
            const res = await interactiveNpy(imgPath, maskPath, () => !isMounted.current)
            setItemInteractiveNpy(item.key, res.output[0])
        } catch (err) {
            console.error(err)
            // props.onClose()
        } finally {
            setItemLoading(item.key, false)
        }
    }

    const childRefs = useRef([])
    const handleCancel = () => {
        props.onClose()
    }
    const handleFinish = async (obj) => {
        setGlobalLoading('生成中...')
        const res = []
        for (let i = 0; i < childRefs.current.length; i++) {
            const ref = childRefs.current[i]
            if (!ref) continue
            const context = ref.onSubmit()
            if (!context.modelBlueMaskBase64) continue
            if (!context.modelBlendedMask) continue

            // 取图片原始尺寸
            const item = list[i]
            const imageWidth = item.originImageWidth
            const imageHeight = item.originImageHeight
            // 蓝色前景图
            let foregroundAlphaMaskBase64 = context.modelBlendedMask
            foregroundAlphaMaskBase64 = await UtilsEdit.resizeImage(foregroundAlphaMaskBase64, imageWidth, imageHeight)
            const foregroundAlphaMaskUrl = await Utils.uploadFile(Utils.convertBase64ToFile(foregroundAlphaMaskBase64, 'image.png'))


            // 二值图
            const binaryMaskBase64 = await UtilsEdit.convertBlueImageToWhite(foregroundAlphaMaskBase64)
            const binaryMaskUrl = await Utils.uploadFile(Utils.convertBase64ToFile(binaryMaskBase64, 'image.jpg'))

            console.log('binaryMaskUrl', binaryMaskUrl)
            console.log('foregroundAlphaMaskUrl', foregroundAlphaMaskUrl)

            // 保存颜色
            const colorHistory = JSON.parse(localStorage.getItem('AIEditColorList') || '[]')
            const filteredHistory = colorHistory.filter(color => color !== selectedColor)
            filteredHistory.unshift(selectedColor)
            if (filteredHistory.length > 10) {
                filteredHistory.length = 10
            }
            localStorage.setItem('AIEditColorList', JSON.stringify(filteredHistory))

            res.push({
                key: item.key,
                editedMask: {
                    binaryMask: binaryMaskUrl,
                    foregroundAlphaMask: foregroundAlphaMaskUrl,
                }
            })

            const recolorRes = await API.doCommodityRecolor({
                projectId: obj.projectId,
                taskId: '',
                num: obj.createNum,
                img: originUrl,
                mask: binaryMaskUrl,
                color: obj.selectedColor,
                projectMask: {
                    algoId: 'algoId',
                    editedOutput: [binaryMaskUrl]
                },
                attr: {
                    multiSemanticRes: {
                        binaryMask: binaryMaskUrl,
                        foregroundAlphaMask: foregroundAlphaMaskUrl,
                    }
                }
            })
            setGlobalLoading(false)
            return recolorRes
        }
        if (res.length == 0) {
            setGlobalLoading(false)
            return message.warning("请选择需要换色的区域")
        }
    }


    const itemRefs = useRef([])
    useEffect(() => {
        itemRefs.current[current]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        })
    }, [current])
    useEffect(() => {
        // 创建控制器和信号
        const controller = new AbortController()
        const signal = controller.signal
        document.addEventListener('keydown', (e) => {
            switch (e.key) {
                case 'ArrowUp':
                    e.preventDefault(); // 阻止默认滚动行为
                    console.log('上一个')
                    setCurrent(pre => Math.max(0, --pre))
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    console.log('下一个')
                    setCurrent(pre => Math.min(list.length - 1, ++pre))
                    break;
            }
        }, { signal })

        return () => {
            // 移除监听
            controller.abort()
        }
    }, [])

    return (
        <div className={styles.Container}>

            {
                originUrl? 
                    <div className={styles.Content}>
                        {
                            list.map((item, index) => (
                                <div key={item.key} style={{ width: '100%', height: '100%', display: current == index ? 'block' : 'none' }}>
                                    <SingleExtraction
                                        ref={el => (childRefs.current[index] = el)}
                                        key={item.key}
                                        uid={item.key}
                                        inputImage={item.url}
                                        imageWidth={item.imageWidth}
                                        imageHeight={item.imageHeight}
                                        multiMasks={item.multiMasks}
                                        editedMask={item.editedMask}
                                        editedMaskBase64={item.editedMaskBase64}
                                        interactiveNpy={item.interactiveNpy}
                                        loading={item.loading}
                                        onCancel={handleCancel}
                                        onFinish={handleFinish}
                                        uploadCb={props.uploadCb}
                                        onChange={(value) => setItemHasEditedMask(item.key, value)}
                                    />
                                </div>
                            ))
                        }
                    </div>: props.defaultPage
            }


            {/* 
            <div className={styles.FloatUpload}>
                <Upload.Dragger
                    accept='image/jpeg,image/png,image/webp,image/avif'
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onDrop={handleDrop}
                    disabled={loading}
                >
                    <Button
                        loading={loading}
                        icon={<Popover content={<ReplaceContent />}><QuestionCircleFilled /></Popover>}
                        iconPosition="end"
                    >替换Mask</Button>
                </Upload.Dragger>
            </div> */}
        </div>
    )
})

export default MultiSemantic